import styles from './BusinessPriorities.module.scss'

interface IBusinessPrioritiesProps {
  value?: string | null
}

export const BusinessPriorities = ({ value }: IBusinessPrioritiesProps) => {
  if (!value) {
    return null
  }

  return (
    <div className={styles.root}>
      {value?.split(',').map((priority) => (
        <div key={priority} className={styles.item}>
          {priority.trim()}
        </div>
      ))}
    </div>
  )
}
